var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
      height: _vm.screenHeight + 'px',
      overflowY: 'scroll',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    })},[_c('div',{staticClass:"text-center"},[_c('img',{staticClass:"empty-image",attrs:{"src":require("@/assets/gif/gifEmpty.gif"),"alt":""}}),_c('p',{staticClass:"empty-text"},[_vm._v(" "+_vm._s(_vm.texts.emptyText)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }